import styled from "styled-components/macro";

export const Header = styled.header(({ theme }) => ({
  position: "absolute",
  width: "100vw",
  padding: "16px 0",
  zIndex: "1",
  [theme.breakpoint.lg()]: {
    width: "0",
    padding: "16px 60px",
    left: 0,
  },
}));
export const Hr = styled.hr(({ theme }) => ({
  width: "98.6vw",
  position: "absolute",
  top: "4.5rem",
  opacity: 0.5,
  [theme.breakpoint.xl()]: {},
}));

export const Container = styled.div(({ theme }) => ({
  maxWidth: "1440px",
  margin: "0",
  padding: "0 16px",

  [theme.breakpoint.lg()]: {
    padding: "0 60px",
  },
}));

export const Content = styled.div(({ theme }) => ({
  margin: "auto",
  display: "flex",
  justifyContent: "center",

  [theme.breakpoint.lg()]: {
    padding: "0px",
    justifyContent: "flex-start",
  },

  [theme.breakpoint.xl()]: {},
}));
